import styled from '@emotion/styled'
import { HorizontalLayout, justifyContents, panelBorderRadius } from 'view/styles/constants'
import { RadioButton } from 'view/components/buttons/RadioButtonStrip'

export interface ButtonStripProps {
  spacing?: string
  horizontalLayout?: HorizontalLayout
}

export const ButtonStrip = styled.div<ButtonStripProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${props => (props.horizontalLayout ? justifyContents[props.horizontalLayout] : justifyContents[HorizontalLayout.Left])};
  & > *:not(:last-child) {
    margin-right: ${props => props.spacing || '0'};
  }
  > {
    ${RadioButton}:nth-of-type(1):first-child {
      border-top-left-radius: ${panelBorderRadius};
      border-bottom-left-radius: ${panelBorderRadius};
    }

    ${RadioButton}:nth-last-of-type(1):last-child {
      border-top-right-radius: ${panelBorderRadius};
      border-bottom-right-radius: ${panelBorderRadius};
    }
  }
  & > * {
    &:nth-child(1) {
      button {
        border-top-left-radius: ${panelBorderRadius};
        border-bottom-left-radius: ${panelBorderRadius};
      }
    }

    &:nth-last-child(1) {
      button {
        border-top-right-radius: ${panelBorderRadius};
        border-bottom-right-radius: ${panelBorderRadius};
      }
    }
  }
`
